export const getPageTitle = (title: string) => `${title} | MYJBI`;
